import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactStars from "react-rating-stars-component";
import i18n from "i18next";

const mySwal = withReactContent(Swal);

class Feedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            clean: 0,
            washer: 0,
            dryer: 0,
            service: 0,
            number: "",
            outletId: "",
            comment: "",
            outlets: [],
            name: ""
        };
    };

    componentDidMount() {
        if (this.props.user) {
            axios.post('/api/user/getOutlet', { operatorId: this.props.operatorId })
                .then(res => {
                    this.setState({
                        ...this.state,
                        name: this.props.user.name,
                        number: this.props.user.number,
                        outlets: res.data,
                    });

                    if (this.props.payment) {
                        const selectedOutlet = this.state.outlets.filter(outlet => outlet.outletName === this.props.payment.outletName)[0];
                        this.setState({
                            ...this.state,
                            outletId: selectedOutlet.outletId,
                            loading: false
                        });
                    } else {
                        this.setState({
                            ...this.state,
                            loading: false
                        });
                    }
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        name: this.props.user.name,
                        number: this.props.user.number,
                        loading: false
                    });
                    mySwal.fire("Error", err.response.data.error, "error");
                });
        } else {
            axios.post('/api/user/getOutlet', { operatorId: this.props.operatorId })
                .then(res => {
                    this.setState({
                        ...this.state,
                        outlets: res.data,
                    });

                    if (this.props.payment) {
                        const selectedOutlet = this.state.outlets.filter(outlet => outlet.outletName === this.props.payment.outletName)[0];
                        this.setState({
                            ...this.state,
                            outletId: selectedOutlet.outletId,
                            loading: false
                        });
                    } else {
                        this.setState({
                            ...this.state,
                            loading: false
                        });
                    }
                })
                .catch(err => {
                    this.setState({
                        ...this.state,
                        loading: false
                    });
                    mySwal.fire("Error", err.response.data.error, "error");
                });
        }
    }

    handleClean = (rating) => {
        this.setState({
            ...this.state,
            clean: rating
        });
    };

    handleWasher = (rating) => {
        this.setState({
            ...this.state,
            washer: rating
        });
    };

    handleDryer = (rating) => {
        this.setState({
            ...this.state,
            dryer: rating
        });
    };

    handleService = (rating) => {
        this.setState({
            ...this.state,
            service: rating
        });
    };

    handleChange = e => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value
        });
    };

    handleSubmit = e => {
        e.preventDefault();

        const { clean, washer, dryer, service, number, outletId, comment, name } = this.state;

        if (clean && washer && dryer && service && number && outletId) {
            mySwal.fire({
                title: i18n.t("Confirmation"),
                text: i18n.t("Are you sure you want to submit your feedback?"),
                icon: "question",
                showCancelButton: true,
                cancelButtonText: i18n.t("No"),
                confirmButtonText: i18n.t("Yes"),
                cancelButtonColor: "#d33",
                customClass: {
                    confirmButton: 'confirm-submit-feedback-yes',
                    cancelButton: 'confirm-submit-feedback-no'
                }
            })
                .then(click => {

                    if (click.isConfirmed && click.value) {
                        this.setState({
                            ...this.state,
                            loading: true
                        });

                        const sendThis = {
                            clean,
                            washer,
                            dryer,
                            service,
                            number,
                            comment,
                            outletId,
                            name
                        };
                        
                        axios.post('/api/user/feedback', sendThis)
                            .then(res => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire(i18n.t("Success"), i18n.t("Your feedback is submitted successfully"), "success").then(() => this.props.history.push(this.props.user ? "/" : "/welcome?operatorCode=" + this.props.operatorId));
                            })
                            .catch(err => {
                                this.setState({
                                    ...this.state,
                                    loading: false
                                });
                                mySwal.fire("Error", err.response.data.error, "error");
                            });
                    }
                })
        } else {
            mySwal.fire(i18n.t("Info"), i18n.t("Please fill in all the required fields before submit."), "info");
        }
    };

    render() {

        return (
            <div id="setting-page">
                <div id="setting-main">
                    <div id="user-header">
                        <h5><i onClick={e => this.props.history.goBack()} className="fas fa-chevron-left me-3"></i> <strong>{i18n.t("Feedback")}</strong></h5>
                    </div>

                    <div id="user-body">
                        <h1 className="text-center pt-3 px-3">{i18n.t("Give us your feedback!")}</h1>
                        <div className="px-5 py-3">
                            <form onSubmit={this.handleSubmit}>

                                <div className="form-group">
                                    <p>{i18n.t("Name")}</p>
                                    <input type="text" name="name" id="name" className="form-control" placeholder={i18n.t("Type your name here (optional)")} onChange={this.handleChange} value={this.state.name} />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Phone Number")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <input type="number" name="number" id="number" className="form-control" placeholder={i18n.t("Type your number here")} onChange={this.handleChange} value={this.state.number} required />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Outlet")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <select name="outletId" id="outletId" className="form-select" value={this.state.outletId} onChange={this.handleChange}>
                                        <option value="" disabled>{i18n.t("Select an outlet")}</option>
                                        {this.state.outlets.map(outlet => <option key={outlet.outletId} value={outlet.outletId}>{outlet.fullname}</option>)}
                                    </select>
                                </div>

                                <div className="form-group pt-3">
                                    <p>{i18n.t("Outlet Cleanliness")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <ReactStars
                                        count={5}
                                        onChange={this.handleClean}
                                        size={55}
                                        activeColor="#ffd700"
                                        value={this.state.clean}
                                    />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Washer Machine Performance")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <ReactStars
                                        count={5}
                                        onChange={this.handleWasher}
                                        size={55}
                                        activeColor="#ffd700"
                                        value={this.state.washer}
                                    />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Dryer Machine Performance")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <ReactStars
                                        count={5}
                                        onChange={this.handleDryer}
                                        size={55}
                                        activeColor="#ffd700"
                                        value={this.state.dryer}
                                    />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Customer Service")} <i style={{ color: "red" }}>*{i18n.t("required")}</i></p>
                                    <ReactStars
                                        count={5}
                                        onChange={this.handleService}
                                        size={55}
                                        activeColor="#ffd700"
                                        value={this.state.service}
                                    />
                                </div>

                                <div className="form-group">
                                    <p>{i18n.t("Comment")}</p>
                                    <textarea id="comment" name="comment" className="form-control" placeholder={i18n.t("Type your comment here (optional)")} onChange={this.handleChange} value={this.state.comment}></textarea>
                                </div>

                                <div>
                                    {
                                        this.state.loading
                                            ? (
                                                <div className="text-center">
                                                    <div className="spinner-border" style={{ color: "#ffd109" }} role="status">
                                                        <span className="sr-only">Loading ...</span>
                                                    </div>
                                                </div>
                                            )
                                            :
                                            <input id="submit-feedback" type="submit" value={i18n.t("SUBMIT")} className="btn btn-primary form-control font-weight-bold mt-5" />
                                    }
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );

    };
};

const mapStateToProps = state => {
    return {
        user: state.user.user,
        operatorId: state.user.operatorId,
        payment: state.payment.machine
    };
};

export default connect(mapStateToProps, null)(Feedback);